import { withCodeNavCacheSqliteSync } from '../../../sqlite/code-nav-cache/database.js';
import { getSymbolIndexParentContext } from './parent-path.js';
import { SYMBOL_INDEX_VERSION } from './symbol-index-version.js';

export function symbolIndexIsPopulated(resolvedParentPath: string): boolean {
  return withCodeNavCacheSqliteSync((db) => {
    const ctx = getSymbolIndexParentContext(db, resolvedParentPath);
    if (ctx == null) return false;

    const versionRow = db.get('SELECT index_version FROM symbol_index_parent_path WHERE id = ?', [
      ctx.parentId,
    ]) as { index_version: number } | null;
    if (versionRow == null || versionRow.index_version < SYMBOL_INDEX_VERSION) return false;

    const ownRow = db.get(
      `SELECT 1 as ok FROM symbol_parent_file_map
       WHERE parent_id = ? AND content_hash IS NOT NULL
       LIMIT 1`,
      [ctx.parentId],
    ) as { ok: number } | null;
    if (ownRow != null) return true;

    if (ctx.baseParentId == null) return false;
    const baseRow = db.get(
      `SELECT index_version FROM symbol_index_parent_path WHERE id = ?`,
      [ctx.baseParentId],
    ) as { index_version: number } | null;
    if (baseRow == null || baseRow.index_version < SYMBOL_INDEX_VERSION) return false;

    const baseMapRow = db.get(
      `SELECT 1 as ok FROM symbol_parent_file_map
       WHERE parent_id = ? AND content_hash IS NOT NULL
       LIMIT 1`,
      [ctx.baseParentId],
    ) as { ok: number } | null;
    return baseMapRow != null;
  });
}
